import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { ServiceCard } from "@/components/Cards";
import { IndependenceStrip } from "@/components/IndependenceStrip";
import { CTAButtons } from "@/components/CTAButtons";
import { NURSING_SERVICES } from "@/data/site";

const Nursing = () => (
  <>
    <Seo
      title="Private Nursing & Home Care in Vietnam"
      description="Doctors Vietnam coordinates short-term private nursing and home care in Vietnam — post-operative nursing, elderly care, mother & baby support and home nursing with licensed independent nurses."
      path="/nursing"
    />
    <PageHero
      eyebrow="Nursing & Home Care"
      title="Recovery and nursing care at your accommodation"
      subtitle="Doctors Vietnam coordinates qualified independent nurses and caregivers to support recovery, daily care and wellbeing at your hotel, home or apartment."
      crumbs={[{ label: "Home", to: "/" }, { label: "Nursing & Home Care" }]}
    >
      <CTAButtons />
    </PageHero>

    <section className="vc-container py-14 sm:py-16">
      <h2 className="sr-only">Nursing and home-care services in Vietnam</h2>
      <div className="grid gap-5 sm:grid-cols-2">
        {NURSING_SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.05}>
            <ServiceCard icon={s.icon} title={s.title} text={s.short} to={`/nursing/${s.slug}`} />
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-8"><IndependenceStrip variant="band" /></Reveal>
    </section>
  </>
);

export default Nursing;
